import { render, staticRenderFns } from "./extension-details.component.vue?vue&type=template&id=9dc7ab9e"
import script from "./extension-details.component.vue?vue&type=script&lang=js"
export * from "./extension-details.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports